import { gql } from '__generated__';

export default gql(`
  query GetOrderStats(
    $project_id: ID!,
    $search: String,
    $events: [ID!],
    $participant_fields: [ParticipantFieldFilter!],
    $participant_field_choices: [ID!],
    $purchase_filters: PurchaseFilters,
    $participant_filters: ParticipantFilters,
  ) {
    project(id: $project_id) {
      id
      order_stats(
        events: $events,
        search: $search,
        participant_fields: $participant_fields,
        participant_field_choices: $participant_field_choices,
        purchase_filters: $purchase_filters,
        participant_filters: $participant_filters,
      ) {
        orders
        purchases
      }
    }
  }
`);
